import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { invoices } from '../../api';
import { currency } from './shared';

const METHODS = ['EFT', 'Cash', 'Card', 'Debit order', 'Other'];

export const PaymentDialog = ({ inv, open, onOpenChange, onSaved, toast }) => {
  const [form, setForm] = useState({ amount: '', date: new Date().toISOString().slice(0, 10), method: 'EFT', reference: '' });
  const [busy, setBusy] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    setBusy(true);
    invoices.addPayment(inv.id, { amount: Number(form.amount), date: `${form.date}T09:00:00Z`, method: form.method, reference: form.reference })
      .then((u) => { toast({ title: 'Payment recorded', description: `${currency(form.amount)} · balance ${currency(u.balance)}` }); onSaved(u); onOpenChange(false); setForm({ ...form, amount: '', reference: '' }); })
      .catch((err) => toast({ title: 'Could not record payment', description: err?.response?.data?.detail || 'Try again.', variant: 'destructive' }))
      .finally(() => setBusy(false));
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle>Record payment · {inv.number}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="text-sm text-stone-600">Balance due: <strong className="text-stone-900">{currency(inv.balance)}</strong></div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="pay-amt">Amount (R)</Label>
              <Input id="pay-amt" type="number" step="0.01" min="0.01" max={inv.balance} required value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="mt-1.5" data-testid="payment-amount-input"/>
              <button type="button" onClick={() => setForm({ ...form, amount: inv.balance })} className="mt-1 text-xs text-emerald-800 hover:underline" data-testid="payment-full-btn">Pay full balance</button>
            </div>
            <div><Label htmlFor="pay-date">Date received</Label><Input id="pay-date" type="date" required value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="mt-1.5" data-testid="payment-date-input"/></div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><Label>Method</Label>
              <Select value={form.method} onValueChange={(v) => setForm({ ...form, method: v })}>
                <SelectTrigger className="mt-1.5" data-testid="payment-method-select"><SelectValue/></SelectTrigger>
                <SelectContent>{METHODS.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label htmlFor="pay-ref">Reference</Label><Input id="pay-ref" value={form.reference} onChange={(e) => setForm({ ...form, reference: e.target.value })} placeholder="Bank ref" className="mt-1.5" data-testid="payment-reference-input"/></div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={busy} className="bg-emerald-800 hover:bg-emerald-900 text-white" data-testid="payment-submit-btn">{busy && <Loader2 size={14} className="mr-2 animate-spin"/>} Record payment</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
